/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordSampleRequestBody
 */
export interface RecordSampleRequestBody {
    /**
     * 
     * @type {Date}
     * @memberof RecordSampleRequestBody
     */
    sampledAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof RecordSampleRequestBody
     */
    numericValue?: number;
    /**
     * 
     * @type {string}
     * @memberof RecordSampleRequestBody
     */
    textValue?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordSampleRequestBody
     */
    sourceRef?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordSampleRequestBody
     */
    notes?: string;
}

/**
 * Check if a given object implements the RecordSampleRequestBody interface.
 */
export function instanceOfRecordSampleRequestBody(value: object): value is RecordSampleRequestBody {
    return true;
}

export function RecordSampleRequestBodyFromJSON(json: any): RecordSampleRequestBody {
    return RecordSampleRequestBodyFromJSONTyped(json, false);
}

export function RecordSampleRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordSampleRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'sampledAt': json['sampledAt'] == null ? undefined : (new Date(json['sampledAt'])),
        'numericValue': json['numericValue'] == null ? undefined : json['numericValue'],
        'textValue': json['textValue'] == null ? undefined : json['textValue'],
        'sourceRef': json['sourceRef'] == null ? undefined : json['sourceRef'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function RecordSampleRequestBodyToJSON(json: any): RecordSampleRequestBody {
    return RecordSampleRequestBodyToJSONTyped(json, false);
}

export function RecordSampleRequestBodyToJSONTyped(value?: RecordSampleRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sampledAt': value['sampledAt'] == null ? undefined : ((value['sampledAt']).toISOString()),
        'numericValue': value['numericValue'],
        'textValue': value['textValue'],
        'sourceRef': value['sourceRef'],
        'notes': value['notes'],
    };
}

